export const environment = {
    production: false,
    API_URI: 'https://videoapp-be.onclass.tech',
    WS_URI: 'https://videoapp-be.onclass.tech',
};

